 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "scripts/" + ({"3":"MenuServices","4":"MenuMagazine","5":"CTAContact","6":"ProjectList","7":"PostCardGrid","8":"RecentSlider","9":"MenuProjects","10":"MenuEvents","11":"ShareComponent","12":"Footer","13":"HomeTeaserGrid","14":"MenuBuildWithUs","15":"PersonItemList","16":"ProjectGrid","17":"ApplicationHeader","18":"TabsBlock","19":"SVG","20":"JobOfferList","21":"ProjectGridProjectItem","22":"TopicBox","23":"TableAgendaItem","24":"dhsv-slider","26":"SocialsBlock","27":"Statements","28":"ImageCarouselItem","29":"SocialShare","30":"SingleEventData","31":"ImageComparison","32":"Button","33":"Header","34":"ExampleComponent","35":"TopicCarouselItem","40":"reactPlayerVidyard","41":"reactPlayerVimeo","42":"TabsItemBlock","46":"EventCardList","47":"reactPlayerMux","49":"reactPlayerPreview","50":"reactPlayerStreamable","52":"reactPlayerYouTube","53":"reactPlayerFacebook","55":"reactPlayerWistia","56":"ImageComponent","57":"reactPlayerTwitch","58":"reactPlayerMixcloud","59":"reactPlayerSoundCloud","61":"reactPlayerDailyMotion","62":"reactPlayerKaltura"}[chunkId]||chunkId) + "_" + {"3":"8cbe25c0a876bf139cde","4":"b4e90f7f853e61fc5f6b","5":"5524969f8ed84325f9a3","6":"84f7016ff84e7f502bbc","7":"1c5114630de6a10a1dd5","8":"0de7c8949884b8f1679d","9":"d373fc9b1dbc49dc9c4a","10":"518fb77885ba5a22e2ca","11":"75af6ee4befcb4eadf63","12":"bf1b5e529af0214911c5","13":"390aeb53b4d6e7391e22","14":"f4ebc0d3e6a3d61c65dd","15":"8d1258ec705f0d6414c0","16":"e9e4001c77b0465d9dee","17":"e311f8c6f7471b9eb64c","18":"eb8a22935b1db78658c0","19":"69b8075cdad50d17b0f4","20":"e96989b5b5f1436a8b52","21":"92e43296da20e04ec6ea","22":"789d0843a4d9948d7e35","23":"f493f7c0654a9a512d06","24":"3e27127f0156b6b03fe4","26":"f42e6f739675d86899db","27":"796302671b8d237d5e77","28":"4335fe643013f2b2d819","29":"3a36e9d4476b77d7b3f4","30":"b5c42f41c1be9936b0df","31":"c0c65a152ab46180a03c","32":"b14563ef97cf7ba35162","33":"cbf54ed0a8939f20e30e","34":"9e882123ca403a19b8c7","35":"3d199d86fc0b79fd77d8","36":"9bd78ac516ec072c4e26","37":"bf48875df1948033ce53","38":"1bb08cd9388a9a135a21","40":"ef97583959afd73003ee","41":"927b10dfea1f2d8ffb82","42":"3013cf39b90883d64d9a","43":"347f41d4e9672f5d71f9","44":"ace3758d2a3bb201deb3","45":"eee4e939536f03aae4cd","46":"e9704c9ada661bb78c8d","47":"d48eb1a40bedc44e16b2","48":"8847a2b2f4e3299004de","49":"7c341ae88a299a6995e8","50":"1b42ccc9a563ce2d8255","51":"c903b1eda43f752d338f","52":"8fb8b62e17b483f3cf19","53":"27ac15f9ccb3ae2da1f7","54":"fee316c51a5325799e9f","55":"a9307f46639dcffcfe8f","56":"7fd2aa4f764a4871e73a","57":"1c8ec647ce566260c818","58":"492d304e412cb791e3a8","59":"7e70f01b284b637b5cef","60":"072f386c4e89f6c160a8","61":"f1fe938576cd275be3b5","62":"f3a96913c32560b000bb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"51":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "styles/" + ({"3":"MenuServices","4":"MenuMagazine","5":"CTAContact","6":"ProjectList","7":"PostCardGrid","8":"RecentSlider","9":"MenuProjects","10":"MenuEvents","11":"ShareComponent","12":"Footer","13":"HomeTeaserGrid","14":"MenuBuildWithUs","15":"PersonItemList","16":"ProjectGrid","17":"ApplicationHeader","18":"TabsBlock","19":"SVG","20":"JobOfferList","21":"ProjectGridProjectItem","22":"TopicBox","23":"TableAgendaItem","24":"dhsv-slider","26":"SocialsBlock","27":"Statements","28":"ImageCarouselItem","29":"SocialShare","30":"SingleEventData","31":"ImageComparison","32":"Button","33":"Header","34":"ExampleComponent","35":"TopicCarouselItem","40":"reactPlayerVidyard","41":"reactPlayerVimeo","42":"TabsItemBlock","46":"EventCardList","47":"reactPlayerMux","49":"reactPlayerPreview","50":"reactPlayerStreamable","52":"reactPlayerYouTube","53":"reactPlayerFacebook","55":"reactPlayerWistia","56":"ImageComponent","57":"reactPlayerTwitch","58":"reactPlayerMixcloud","59":"reactPlayerSoundCloud","61":"reactPlayerDailyMotion","62":"reactPlayerKaltura"}[chunkId]||chunkId) + "_" + {"3":"e1f1fb8badedc8758bf0","4":"2c20568e7d20826ff32d","5":"6c52ad33dd61bfc5918f","6":"8cbfed82bdd927921c0c","7":"e7161b5ea15702423c2a","8":"e8a5bae4192486818a96","9":"844ae514bd366413c089","10":"cfa48f450f2878226a9b","11":"b14640d83052a3d79cf2","12":"1d949d4613ce0e2a98bd","13":"b09da76d83f385da60ab","14":"077770368dc92decfd19","15":"6afd0bcf7d6b274aeff1","16":"bb079fff26a8553e9e81","17":"29509a80befb374adc9b","18":"e79c05e23f602b632930","19":"0be2722361036b6bc311","20":"ead31fc6d4ccb89e186c","21":"593c794f449e9ca948a3","22":"7539348bcdfe7edc0a38","23":"078758d0b68d84edb6ea","24":"25634023f89993c99250","26":"04bbb1a56795839a9baf","27":"95a3a51c8b4cf0ebd9c6","28":"0710845502d7320b89dc","29":"e5f9f0257ad371e9a495","30":"fce02927efb8a1b688a0","31":"9b095fddfb6a92a41932","32":"e9560a5df02fc37e77b0","33":"bacd12fc3bec02495a19","34":"aa7ce486e8a6afff27c4","35":"9dc86e560ec3e7661f47","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"f06f8cd7fc9f8c334584","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"854d09bbc06c71255000","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/wp-content/themes/360vier-theme/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,39]);
 	// run deferred modules when ready
 	return checkDeferredModules();
